import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import { Text } from "@nxt-costco-com/forge-components";
import { SpaceXxs, ColorTextLight } from "@nxt-costco-com/forge-design-tokens";
const ProductAttributesRenderer = ({
  productAttributes = []
}) => {
  if (!(productAttributes == null ? void 0 : productAttributes.length)) return null;
  return /* @__PURE__ */ jsx(Fragment, { children: productAttributes.map((attribute) => {
    const isLastItem = attribute.key === productAttributes[productAttributes.length - 1].key;
    if (isLastItem) {
      return /* @__PURE__ */ jsx(
        Text,
        {
          sx: {
            color: ColorTextLight,
            marginRight: SpaceXxs
          },
          variant: "t7",
          children: `${attribute.key}: ${attribute.value}`
        },
        attribute.key
      );
    } else {
      return /* @__PURE__ */ jsxs(
        Text,
        {
          sx: {
            color: ColorTextLight,
            marginRight: SpaceXxs
          },
          variant: "t7",
          children: [
            `${attribute.key}: ${attribute.value}`,
            /* @__PURE__ */ jsx("span", { "aria-hidden": "true", children: ` |` })
          ]
        },
        attribute.key
      );
    }
  }) });
};
export {
  ProductAttributesRenderer as default
};
